import React from "react";
import { navigate } from "gatsby";
import PropTypes from "prop-types";
import { Card as BootstrapCard, Button } from "react-bootstrap";

import RichTextBlock from "./RichTextBlock";

import "../styles/components/Card.scss";

const Card = ({
    customId,
    title,
    copy,
    link,
    linkText = "Learn More →",
    onClick,
}) => {
    const defaultOnClick = e => {
        e.preventDefault();
        if (!link) {
            return;
        }

        navigate(link);
    };

    return (
        <BootstrapCard id={customId}>
            <BootstrapCard.Body className="d-flex flex-column">
                {title && (
                    <>
                        <BootstrapCard.Title className="title mb-2 pr-md-5">
                            {title}
                        </BootstrapCard.Title>
                        <hr className="rounded mb-3" />
                    </>
                )}
                <div className="card-copy">
                    <RichTextBlock content={copy} />
                </div>

                {link && (
                    <Button
                        variant="link"
                        onClick={onClick ? onClick : defaultOnClick}
                        className="learn-more mt-auto ms-auto"
                    >
                        {linkText}
                    </Button>
                )}
            </BootstrapCard.Body>
        </BootstrapCard>
    );
};

Card.propTypes = {
    customId: PropTypes.string,
    title: PropTypes.string.isRequired,
    copy: PropTypes.shape({ raw: PropTypes.string }).isRequired,
    link: PropTypes.string,
    linkText: PropTypes.string,
    onClick: PropTypes.func,
};

export default Card;
